/**
 * @namespace es.util.browser
 */
export default class BrowserUtil {
    /**
     * @function es.util.browser.isIE Detect if browser used is Internet Explorer
     */
    isIE(): boolean {
        return (navigator.userAgent.indexOf("MSIE") != -1) ||( !!navigator.userAgent.match(/Trident.*rv\:11\./)) || ( !!navigator.userAgent.match(/ Edge\//));
    }

    /**
     * 
     * @returns 
     */
    getIEMajorVersion(): number {
        //"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586"

        if (!!navigator.userAgent.match(/ Edge\//)) {
            return parseInt(navigator.userAgent.substring(navigator.userAgent.indexOf(" Edge/") + 6));
        }

        if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            return 11;
        }
        
        return parseInt(navigator.userAgent.substring(navigator.userAgent.indexOf("MSIE") + 5));
    }

    /**
     * @function es.util.browser.isChrome Detect if browser used is Chrome
     */
    isChrome(): boolean {
        return (navigator.userAgent.indexOf("Chrome") != -1) && (navigator.userAgent.indexOf("Opera") == -1); // Opera fakes it's also Chrome - https://stackoverflow.com/questions/5899783/detect-safari-using-jquery
    }

    /**
     * @function es.util.browser.isChromeOnMac Detect if browser used is Chrome on a Mac
     */
    isChromeOnMac(): boolean {
        return (navigator.userAgent.indexOf("Chrome") != -1) && (navigator.platform.indexOf("Mac") != -1); // Opera fakes it's also Chrome - https://stackoverflow.com/questions/5899783/detect-safari-using-jquery
    }

    /**
     * @function es.util.browser.isSafari Detect if browser used is Safari
     */
    isSafari() {
        return (navigator.userAgent.indexOf("Safari") != -1) && (navigator.userAgent.indexOf("Chrome") == -1); // Chrome fakes it's also Opera - https://stackoverflow.com/questions/5899783/detect-safari-using-jquery
    }

    /**
     * @function es.util.browser.isIE Detect if browser used is Firefox
     */
    isFirefox() {
        return navigator.userAgent.indexOf("Firefox") != -1;
    }

    /**
     * @function es.util.browser.isIE Detect if browser used is Opera
     */
    isOpera() {
        return navigator.userAgent.indexOf("Opera") != -1;
    }

    isFileApi() {
        return window.File !== undefined
            && window.FileReader !== undefined
            && window.FileList !== undefined
            && window.Blob !== undefined;
    }

    /**
    * iOS version detection
    */
    //TODO FIX ME This regex seems to be outdated and returns false on iOS (iPad)
    iOS() {
        return parseFloat(
            ('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0,''])[1])
                .replace('undefined', '3_2').replace('_', '.').replace('_', '')
        ) || false
    }
}
